import React from 'react'
import { statusType } from '../../../../actions'
import { Button, SectionSearch, Toolbar, ToolbarRow } from '../../../../components'
import { THEMES } from '../../../../utils/ui'

const ContactToolbarComponent = ({ noData, toggleSidebar, exportStatus, handleExport, handleFilterChange }) => {
  const handleSearchChange = (query) => handleFilterChange({ query, page: 1 })

  return (
    <Toolbar>
      <ToolbarRow justified>
        <div className='toolbar_group'>
          <button className={'button button--steel'} onClick={toggleSidebar}>
            <i className='button_icon q4i-funnel-filter-4pt' /> Filter
          </button>
        </div>

        <div className='toolbar_group'>
          <SectionSearch onQueryChange={handleSearchChange} onClear={handleSearchChange} />

          <Button
            loading={exportStatus === statusType.IN_PROGRESS}
            theme={THEMES.STEEL}
            icon='q4i-download-4pt'
            label='Export'
            disabled={noData}
            onClick={handleExport} />
        </div>
      </ToolbarRow>
    </Toolbar>
  )
}

export default ContactToolbarComponent
